import { FeatureSwitch } from '@loop/comm-feature-switches-dom';
import { buildParticipantDisplayString } from './build-participant-display-list';
const { HIDE_CONVERSATION_ALIAS, HIDE_CONV_LIST_PARTICIPANTS, SHOW_CONVERSATION_ALIAS_BEFORE_PARTIES, SHOW_CONVERSATION_TEAM, SHOW_CONV_STAFF_LIST_PARTICIPANTS, } = FeatureSwitch;
export const buildDetailLine = (displayDetail, displayId) => {
    if ((displayDetail && displayDetail.length) || (displayId && displayId.length)) {
        const both = displayDetail && displayDetail.length && displayId && displayId.length;
        return `${displayId || ''}${both ? ': ' : ''}${displayDetail || ''}`;
    }
    return undefined;
};
export const buildConversationLabel = ({ featureSwitches, type, participantDisplay, aliasDisplay, displayDetail, displayId, mbcDisplay, teamName, displayInitials, isTemplate, pinned, }) => {
    const staffOnly = type === 'DIRECT' || type === 'INTERNAL' || type === 'CHANNEL';
    const separateStaff = featureSwitches[SHOW_CONV_STAFF_LIST_PARTICIPANTS] && (type === 'EXTERNAL' || type === 'CHANNEL');
    const info = [];
    const includeMbc = !!mbcDisplay;
    if (includeMbc) {
        info.push({
            type,
            key: 'mbc-display',
            title: mbcDisplay,
        });
    }
    const includeParticipants = !!(participantDisplay &&
        type !== 'CHANNEL' &&
        !featureSwitches[HIDE_CONV_LIST_PARTICIPANTS] &&
        !mbcDisplay);
    if (includeParticipants) {
        info.push({
            type,
            pinned,
            key: 'participants',
            title: buildParticipantDisplayString(participantDisplay, {
                staffOnly,
                isTemplate,
                externalPartiesOnly: !staffOnly && separateStaff,
                hideCurrentUser: !!isTemplate || !featureSwitches[HIDE_CONVERSATION_ALIAS],
            }),
        });
    }
    const includeAlias = !!(aliasDisplay && !featureSwitches[HIDE_CONVERSATION_ALIAS]);
    if (includeAlias) {
        const aliasLine = {
            type,
            key: 'alias',
            title: aliasDisplay,
        };
        let descriptionLine;
        if (type === 'INTERNAL' || type === 'EXTERNAL') {
            if ((displayDetail && displayDetail.length) || (displayId && displayId.length)) {
                descriptionLine = {
                    type,
                    key: 'matter-description',
                    title: buildDetailLine(displayDetail, displayId),
                };
            }
        }
        if (featureSwitches[SHOW_CONVERSATION_ALIAS_BEFORE_PARTIES] && type !== 'INBOX') {
            if (descriptionLine) {
                info.unshift(descriptionLine);
            }
            info.unshift(aliasLine);
        }
        else {
            info.push(aliasLine);
            if (descriptionLine) {
                info.push(descriptionLine);
            }
        }
    }
    const includeSeparateStaff = !!(participantDisplay && separateStaff && type !== 'CHANNEL');
    if (includeSeparateStaff) {
        info.push({
            type,
            key: 'staff-participants',
            title: (participantDisplay || []).filter(({ isStaff }) => isStaff).map(displayInitials),
        });
    }
    const includeConversationTeam = !!(teamName && featureSwitches[SHOW_CONVERSATION_TEAM]);
    if (includeConversationTeam) {
        info.push({ type, key: 'conversation-team', title: teamName });
    }
    return info;
};
//# sourceMappingURL=build-conversation-label.js.map